



























































declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;
declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

import { Component, Prop, Vue } from "vue-property-decorator";
import { TCModel } from "@iabtcf/core";

@Component
export default class LayerOne extends Vue {
	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = gGDPR_logoURL;
  features : any[] = [] 
  stacks : any[] = [] 

	mounted(): void {
		if (gGDPR_privacyPolicyURL) this.privacyPageURL = gGDPR_privacyPolicyURL;



		//@ts-ignore
		let model: TCModel = window.__cmpTCModel;
		//@ts-ignore
		this.features = model.gvl.specialFeatures;
		this.stacks = [ model.gvl.purposes["1"], model.gvl.stacks["42"] ];


	}

	manageSettingsClick(): void {
		this.$emit("changeViewEvent", "layerTwo");
	}

	vendorsClick(): void {
		this.$emit("changeViewEvent", "layerThree");
	}

	acceptAllClick(): void {
    // @ts-ignore
    window.__cmpTCModel.setAll();
    // @ts-ignore
    window.__cmpTCModel.purposeLegitimateInterests.empty();
    // @ts-ignore
    window.__cmpTCModel.vendorLegitimateInterests.empty();

    if ( gGDPR_NonTCFVendors  ) {
      gGDPR_NonTCFVendors.forEach(( element:object, index : number, a:Array<object> ) => {
      // @ts-ignore
      gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = true;
      });
    }

//@ts-ignore
		this.$root.storeTCString();

		this.$emit("changeViewEvent", "close");
	}
}
